//@flow
import { QueryRenderer } from 'react-relay';
import { useIntl } from 'dibs-react-intl';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';

import { getEnvironment } from '../../../relayModernEnvironment';
import { Error, Loader } from '../../../shared';
import { logError } from '../../../helpers';
import { ConnectFolderQuery } from './ConnectFolderQuery';
import { FolderMenu } from './FolderMenu';

type OuterProps = {
    firmId: ?string,
    firmMembers: Array<?string>,
    intl: intlShape,
    onClose: Function,
    onFolderSelection: Function,
};

export function ConnectFolderModal(outerProps: OuterProps) {
    const intl = useIntl();
    const { firmId, firmMembers, onClose, onFolderSelection } = outerProps;

    let modalContent = null;

    if (!firmId) {
        logError('Attempting to display connect modal when no firm ID present.');
        modalContent = <Error />;
    } else if (firmMembers && !firmMembers.length) {
        logError(`Attempting to display connect modal for empty firm ID ${firmId}.`);
        modalContent = <Error />;
    } else {
        modalContent = (
            <QueryRenderer
                environment={getEnvironment()}
                variables={{ firmMembers }}
                query={ConnectFolderQuery}
                render={({ error, props }) => {
                    if (error) {
                        logError(error);
                        return <Error />;
                    } else if (!props) {
                        return <Loader />;
                    } else {
                        return (
                            <FolderMenu
                                {...props}
                                closeModal={onClose}
                                firmId={firmId}
                                onFolderSelection={onFolderSelection}
                            />
                        );
                    }
                }}
            />
        );
    }

    return (
        <ModalContainer dataTn="connect-folder-modal" isOpen onClose={onClose}>
            <BarHeader
                title={intl.formatMessage({
                    id: 'abt.designProfile.ConnectFolderModal.title',
                    defaultMessage: 'Choose a Folder',
                })}
            />
            <ModalCloseButton onClick={onClose} />
            <ModalBody>{modalContent}</ModalBody>
        </ModalContainer>
    );
}
